import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=542d580c&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=542d580c&prod&lang=scss&scoped=true"
import style1 from "./Products.vue?vue&type=style&index=1&id=542d580c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d580c",
  null
  
)

export default component.exports